export default "__VITE_ASSET__B_F7H6ER__"